import React from "react";
import { Link } from "react-router-dom";
import { Image, Popconfirm } from "antd";
import { DeleteFilled, StarFilled } from "@ant-design/icons";
import api from "../services/Api";

const UserAuctionList = ({ auctions, onDeleteSuccess }) => {
    const statusColors = {
        draft: "#f9a826",
        published: "#3bb54a",
        sold: "#d0021b",
        expired: "#b0b0b0",
        cancelled: "#ee4400",
    };

    const auctionTypes = {
        auction: "Huutokauppa",
        sale: "Myynti",
        rent: "Vuokraus",
    };

    const handleAuctionDelete = async (uuid) => {
        try {
            await api.deleteAuction(uuid);
            onDeleteSuccess(); // Trigger re-fetching of auctions
        } catch (error) {
            console.error("Error deleting auction:", error);
        }
    };

    return (
        <>
            {auctions.length === 0 && <p>Ei ilmoituksia</p>}
            {auctions.map((auction) => (
                <div className="flex" key={auction.id}>
                    <Link
                        to={`/oma-sivu/ilmoitukset/${auction.uuid}`}
                        className="bg-gray-100 hover:bg-gray-200 hover:text-primary rounded mb-2 flex flex-1"
                    >
                        <div
                            style={{ backgroundColor: `${statusColors[auction.status]}` }}
                            className="rounded uppercase w-2"
                        ></div>
                        <div className="flex items-center">
                            <Image
                                className="ml-3"
                                width={75}
                                height={75}
                                src={auction.images[0]?.urls.thumbnail}
                                fallback="data:image/png;base64,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"
                            />
                        </div>
                        <div className="grow p-2 ml-5 relative">
                            <div className="absolute right-2 hidden md:block top-2 z-20 bg-primary text-white px-1 py-0 rounded">
                                {auctionTypes[auction.type]}
                            </div>
                            <h2 className="text-base md:text-lg font-semibold mb-2">
                                #{auction.number} {auction.title}, viikko {auction.propertyWeek}
                            </h2>
                            {auction.featuredUntil && (
                                <div className="">
                                    <StarFilled className="text-green-600" /> Nostettu etusivulle{" "}
                                    {auction.featuredUntil} asti.
                                </div>
                            )}
                            <p className="text-gray-500">{auction.short_description}</p>
                        </div>
                    </Link>
                    {auction.status === "draft" && (
                        <div className="flex items-center ml-5">
                            <Popconfirm
                                title="Haluatko varmasti poistaa luonnoksen?"
                                okText="Kyllä"
                                cancelText="Peruuta"
                                onConfirm={() => handleAuctionDelete(auction.uuid)}
                            >
                                <DeleteFilled className="text-red-600 text-lg" onClick={(e) => e.stopPropagation()} />
                            </Popconfirm>
                        </div>
                    )}
                </div>
            ))}
        </>
    );
};

export default UserAuctionList;
